import React from 'react';
import { ShowLayout } from 'components/details';
import { CardTitle } from 'components/common';
import { Delivery } from 'icons';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import { get } from 'lodash';
import { LabeledValueField } from 'components/fields';
import Divider from './Divider';

const useStyles = makeStyles((theme) => ({
  label: {
    lineHeight: '20px',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(0.5),
  },

  value: {
    fontSize: 16,
    lineHeight: 1.25,
    fontWeight: 'bold',
  },

  sectionTitle: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
    textTransform: 'uppercase',
  },

  descriptionList: {
    '& > :not(:first-child)': {
      marginTop: theme.spacing(2),
    },
  },
}));

const DeliveryOptionsSection = (props) => {
  const classes = useStyles();

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={4}>
          <Typography className={classes.label} component="div" variant="overline">
            Signature
          </Typography>
          <Typography data-test="signature" className={classes.value} variant="body1">
            {get(props, 'record.params.signature') ? 'Yes' : 'No'}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography className={classes.label} component="div" variant="overline">
            Insurance
          </Typography>
          <Typography data-test="insurance" className={classes.value} variant="body1">
            {get(props, 'record.params.insurance') ? 'Yes' : 'No'}
          </Typography>
        </Grid>
        {!!get(props, 'record.params.insurance') && (
          <Grid item xs={4}>
            <Typography className={classes.label} component="div" variant="overline">
              Insurance value
            </Typography>
            <Typography data-test="residential" className={classes.value} variant="body1">
              {get(props, 'record.params.packageInfo[0].insuredValue')}
            </Typography>
          </Grid>
        )}
      </Grid>
    </>
  );
};

const formatDeliveryStatus = (status) => {
  if (!status) {
    return '-';
  }

  return status
    .toLowerCase()
    .split('_')
    .join(' ')
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
};

const formatDeliveryUpdatedAt = (value) => {
  if (!value) {
    return '-';
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return '-';
  }

  return date.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
};

const DeliveryDescriptionSection = (props) => {
  const classes = useStyles();

  if (!props.record?.delivery) {
    return null;
  }

  return (
    <>
      <Divider />
      <div className={classes.descriptionList}>
        <LabeledValueField
          {...props}
          label="Description"
          source="delivery.description"
          formatter={(value) => value || '-'}
        />
        <LabeledValueField
          {...props}
          label="Status"
          source="delivery.status"
          formatter={formatDeliveryStatus}
        />
        <LabeledValueField
          {...props}
          label="Updated at"
          source="delivery.updatedAt"
          formatter={formatDeliveryUpdatedAt}
        />
      </div>
    </>
  );
};

const DeliveryCard = () => (
  <ShowLayout
    showingFields={[
      'record.params.signature',
      'record.params.insurance',
      'record.params.packageInfo[0].insuredValue',
      'record.delivery.description',
      'record.delivery.status',
      'record.delivery.updatedAt',
    ]}>
    <CardTitle icon={<Delivery />}>Delivery</CardTitle>
    <DeliveryOptionsSection />
    <DeliveryDescriptionSection />
  </ShowLayout>
);

export default DeliveryCard;
